import React from 'react';
import { ClinicAIHero } from '../components/BlogIllustrations';
import BlogArticle, { ArticleH2, WeekPlan } from '../components/BlogArticle';

const workflows = [
  ['intake', 'Intake triage and routing', 'Automate structured intake, triage logic, and queue routing to reduce front-desk overload.'],
  ['reminders', 'Appointment reminders and no-show prevention', 'Use reminder sequences with confirmation links and escalation rules to improve attendance.'],
  ['referrals', 'Referral and requisition packet preparation', 'Auto-assemble packets from templates and validate required fields before submission.'],
  ['follow-up', 'Follow-up task orchestration', 'Trigger follow-up tasks based on visit completion, test results, and response delays.'],
  ['documents', 'Document classification and filing', 'Classify incoming documents and route to the right queue to reduce filing time.'],
  ['faq', 'FAQ and after-hours response assistant', 'Handle approved non-clinical FAQs consistently and reduce repetitive calls.'],
  ['dashboard', 'Weekly operational dashboard and alerts', 'Provide weekly summaries and threshold-based alerts so teams act before bottlenecks grow.'],
];

function BlogPostClinicAI() {
  return (
    <BlogArticle
      slug="ai-automation-for-canadian-clinics"
      tags={['Healthcare AI']}
      title={<>AI Automation for Canadian Clinics: 7 Workflows You Can Deploy in <em>30 Days</em></>}
      lead="Canadian clinics don’t need a massive digital transformation to get value from AI. Most teams can reclaim admin time in weeks by automating repetitive, high-volume workflows while keeping privacy and patient safety front and center."
      figure={<ClinicAIHero />}
      proseClass="blog-prose--plain"
      cta={{
        title: 'Ready to map your first two automation wins?',
        text: 'Book a 30-minute session and we’ll turn your highest-friction workflows into a practical rollout plan.',
        label: 'Book a Demo',
      }}
    >
      <ol className="blog-flows" data-reveal-stagger>
        {workflows.map(([id, title, text], i) => (
          <li className="blog-flow" key={id}>
            <span className="blog-flow__num" aria-hidden="true">{String(i + 1).padStart(2, '0')}</span>
            <h2 className="blog-flow__title" id={id} tabIndex={-1}>
              <span className="visually-hidden">{i + 1}) </span>{title}
            </h2>
            <p className="blog-flow__text">{text}</p>
          </li>
        ))}
      </ol>

      <ArticleH2 id="rollout">30-day rollout</ArticleH2>
      <WeekPlan
        label="30-day rollout"
        items={[
          ['Week 1', 'Workflow mapping, baseline metrics, privacy review'],
          ['Week 2', 'Deploy first two workflows + staff testing'],
          ['Week 3', 'Deploy 2–3 supporting workflows'],
          ['Week 4', 'Stabilization, SOP handoff, optimization'],
        ]}
      />
    </BlogArticle>
  );
}

export default BlogPostClinicAI;
